import { defineNuxtPlugin, useRouter } from '#imports';
import { handleError, logError } from '~/api';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.onError(import.meta.client ? handleError : logError);
});
